<template>
  <div id="app">
    <component :is="this.$route.meta.layout || 'div'">
      <router-view />
      <!--Start:Global snackbar-->
      <v-snackbar v-model="snackbar.show" :timeout="snackbar.timeout" left multi-line>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn color="primary" text v-bind="attrs" @click="hideSnackbar" top>
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!--End:Global snackbar-->
    </component>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapGetters(["snackbar"]),
  },
  methods: {
    ...mapActions(["hideSnackbar"]),
  },
};
</script>
<style>
.v-btn {
  text-transform: none !important;
}

.dropzone {
  background-color: #fce1d6 !important;
  border-color: #f79c76 !important;
  border-style: dashed !important;
}

.dropzone .dz-message {
  margin: 0 0 !important;
  margin-top: 18px !important;
  margin-right: 0px !important;
  margin-bottom: 0px !important;
  margin-left: 0px !important;
}

.text-transform-capitalize input {
  text-transform: capitalize !important;
}

.vc-am-pm button.active {
  background: #f15e31 !important;
}

.vc-date .vc-month,
.vc-date .vc-day {
  color: #f15e31 !important;
  text-transform: capitalize;
}

.vc-date .vc-weekday {
  text-transform: capitalize;
}

.vc-am-pm button.active:focus,
.vc-am-pm button.active:hover {
  border-color: #f15e31 !important;
}

.vc-am-pm button:focus {
  border-color: transparent !important;
}

.vc-select select:focus {
  border-color: #f15e31 !important;
}

.vc-pane-container {
  font-family: "Roboto" !important;
}

/*CSS for the sponsors dropzone */
#sponsorsLogoDropzone .dz-message {
  height: 100% !important;
  margin-top: unset !important;
}
</style>
